/**
 * @prettier
 */
export function openTermsAndConditionsPageInNewTab(): void {
    window.open('https://pidedirecto.mx/politicas', '_blank');
}
